import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchSalesAgenciesApi } from 'api/sales_agency'
import { SalesAgency, SalesAgencySearchForm } from 'entities/sales_agency'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { salesAgencyColumnInfoList, SalesAgencyTableData } from './sales_agency_table'
import { DisplaySetting, DisplaySettingModal, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditSalesAgencyForm, NewSalesAgencyForm } from './sales_agency_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const SalesAgenciesPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<SalesAgencySearchForm>()
    const searchForm = useForm<SalesAgencySearchForm>(query)
    const api = useFetchSalesAgenciesApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<SalesAgency>()
    const salesAgencyDisplaySetting = useDisplaySetting(salesAgencyColumnInfoList(searchForm), 'SalesAgency')
    const displaySettings: DisplaySetting[] = [salesAgencyDisplaySetting]
    const [selectedSalesAgency, setSelectedSalesAgency] = useState<SalesAgency>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof SalesAgencySearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`sales_agencies?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            <EditSalesAgencyForm
                salesAgency={selectedSalesAgency}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="営業代行"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewSalesAgencyForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<DisplaySettingModal displaySettings={displaySettings} />}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={salesAgencyDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={salesAgencyDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((salesAgency: SalesAgency) => {
                                return (
                                    <CheckboxTableRow key={`salesAgency-${salesAgency.id}`} item={salesAgency} multipleCheckForm={multipleCheckForm}>
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedSalesAgency(salesAgency)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <SalesAgencyTableData salesAgency={salesAgency} displaySetting={salesAgencyDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="SalesAgency"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(SalesAgenciesPage)
